import { useQuery } from 'react-query';

import { getActionPlanFocusAreas } from 'apis/ActionPlansAPI';

import { SelectOption } from './CreateEditActionPlansModalTypes';

const useActionPlanFocusAreas = () => {
  const { data = [], isLoading } = useQuery({
    queryKey: ['action-plan-focus-areas'],
    queryFn: getActionPlanFocusAreas,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const focusAreaOptions: SelectOption[] = data.map((focusArea) => ({
    label: focusArea.name,
    value: focusArea.id,
  }));

  const focusAreaLabelById: Record<number, string> = Object.fromEntries(
    data.map((focusArea) => [focusArea.id, focusArea.name])
  );

  return { focusAreas: data, focusAreaOptions, focusAreaLabelById, isLoading };
};

export default useActionPlanFocusAreas;
